import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Sparkles } from 'lucide-react';
import ProductSlider from '@/components/ProductSlider';
import { asArray, cn } from '@/lib/utils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * منتجات مشابهة للي اتشاف (ids الأحدث أولاً). بيختفي لو مفيش ids أو مفيش نتايج.
 * showBasedOn: يعرض "لأنكِ شاهدتِ: ..." كروابط.
 */
const RecommendedSection = ({ ids, title = 'مختارات لكِ', eyebrow = 'بناءً على تصفحك', showBasedOn = true, className }) => {
  const [data, setData] = useState({ products: [], based_on: [] });
  const key = ids.join(',');

  useEffect(() => {
    if (!key) {
      setData({ products: [], based_on: [] });
      return;
    }
    let cancelled = false;
    axios
      .get(`${API}/products/recommendations`, { params: { ids: key, limit: 10 } })
      .then((res) => {
        if (!cancelled) setData({ products: asArray(res.data?.data?.products), based_on: asArray(res.data?.data?.based_on) });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [key]);

  if (!data.products.length) return null;

  return (
    <section className={cn('py-12 md:py-16', className)} aria-label={title}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-[1600px]">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-6 md:mb-10">
          <div className="min-w-0">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-cairo font-bold text-brand-gold mb-2">
              <Sparkles className="w-4 h-4" /> {eyebrow}
            </p>
            <h2 className="text-2xl md:text-4xl font-tajawal font-extrabold text-brand-black">{title}</h2>
            {showBasedOn && data.based_on.length > 0 && (
              <p className="mt-2 flex flex-wrap items-center gap-1.5 font-cairo text-sm text-gray-500">
                لأنكِ شاهدتِ:
                {data.based_on.map((p) => (
                  <Link
                    key={p.id}
                    to={`/products/${p.id}`}
                    className="inline-flex items-center rounded-full bg-burgundy-500/[0.07] text-burgundy-600 px-2.5 py-0.5 text-xs font-semibold hover:bg-burgundy-500 hover:text-white transition-colors"
                  >
                    {p.name}
                  </Link>
                ))}
              </p>
            )}
          </div>
        </div>
        <ProductSlider products={data.products} />
      </div>
    </section>
  );
};

export default RecommendedSection;
